import API from "@/api";

export default {
	api: API.system.file.upload,			//上传请求API对象
	checkApi: API.system.file.check,
	filename: "file",					//form请求时文件的key
	successCode: 0,					//请求完成代码
	maxSize: 10,						//最大文件大小 默认10MB
	parseData: function (res) {
		return {
			fileName: res.file_name,
			src: res.file_path,
		}
	}
}
